export function formatPrice(amount) {
  const config = window.symplePOS || {};
  const decimals = config.decimals ?? 2;
  const decimalSep = config.decimalSep || '.';
  const thousandSep = config.thousandSep || ',';
  const symbol = config.currencySymbol || '$';
  const position = config.currencyPosition || 'left';

  const fixed = Math.abs(amount).toFixed(decimals);
  const [intPart, decPart] = fixed.split('.');
  const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep) + (decimals > 0 ? decimalSep + decPart : '');
  const signed = amount < 0 ? '-' : '';

  switch (position) {
    case 'left': return signed + symbol + formatted;
    case 'left_space': return signed + symbol + ' ' + formatted;
    case 'right': return signed + formatted + symbol;
    case 'right_space': return signed + formatted + ' ' + symbol;
    default: return signed + symbol + formatted;
  }
}
